import React from "react";
import KidepoHeadrer from "./KidepoHeadrer";
import KidepoSection from "./KidepoSection";

const Kidepo = () => {
  return (
    <div data-new-gr-c-s-check-loaded="14.1231.0" data-gr-ext-installed>
      <KidepoHeadrer />
      <KidepoSection />
    </div>
  );
};

export default Kidepo;
